'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// Redux


// Configure the router


var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _I18n = require('I18n');

var I18n = _interopRequireWildcard(_I18n);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _handlers = require('q/js/handlers');

var _legacyHubspotBenderContext = require('legacy-hubspot-bender-context');

var _debug = require('conversations-lib/debug');

var _WidgetUi = require('conversations-schema/records/WidgetUi');

var _WidgetUi2 = _interopRequireDefault(_WidgetUi);

require('Redux');

var _reactRedux = require('react-redux');

var _buildStore = require('conversations-visitor-ui/buildStore');

var _buildStore2 = _interopRequireDefault(_buildStore);

var _AppActions = require('conversations-core/actions/AppActions');

var AppActions = _interopRequireWildcard(_AppActions);

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _Routes = require('conversations-visitor-ui/Routes');

var _Routes2 = _interopRequireDefault(_Routes);

var _ClientData = require('conversations-schema/records/ClientData');

var _ClientData2 = _interopRequireDefault(_ClientData);

var _BenderContext = require('conversations-schema/records/BenderContext');

var _BenderContext2 = _interopRequireDefault(_BenderContext);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Application = function () {
  function Application() {
    _classCallCheck(this, Application);
  }

  _createClass(Application, [{
    key: 'start',
    value: function start() {
      var _this = this;

      window.AppInstance = this;
      (0, _handlers.logQPromiseIssuesAndSendAlerts)();
      _hubspot2.default.get();
      I18n.when('ready', function () {
        _this.startRedux();
        _this.startRouter();
      });
    }
  }, {
    key: 'getQueryParam',
    value: function getQueryParam(param) {
      var url = new _hubspotUrlinator2.default(window.location);
      return url.paramValue(param);
    }
  }, {
    key: 'startRedux',
    value: function startRedux() {
      var hubspotUtk = this.getQueryParam('hubspotUtk');
      var messagesUtk = this.getQueryParam('messagesUtk');
      var mobile = this.getQueryParam('mobile') === 'true';
      var open = this.getQueryParam('open') === 'true';
      var hideWelcomeMessage = this.getQueryParam('hideWelcomeMessage') === 'true';

      var domain = this.getQueryParam('domain');
      var url = decodeURIComponent(this.getQueryParam('url'));

      this.store = (0, _buildStore2.default)({
        benderContext: new _BenderContext2.default((0, _immutable.fromJS)(_legacyHubspotBenderContext.bender)),
        clientData: new _ClientData2.default({ isAdmin: false }),
        prospectUtks: {
          messagesUtk: messagesUtk,
          hubspotUtk: hubspotUtk
        },
        widgetUi: (0, _WidgetUi2.default)({
          mobile: mobile,
          open: open,
          hideWelcomeMessage: hideWelcomeMessage,
          domain: domain,
          url: url
        })
      });
      (0, _debug.setupDebug)(this.store);
      this.store.dispatch(AppActions.start());
    }
  }, {
    key: 'startRouter',
    value: function startRouter() {
      var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, this.store);
      (0, _reactDom.render)(_react2.default.createElement(
        _reactRedux.Provider,
        { store: this.store },
        _react2.default.createElement(
          _reactRouter.Router,
          { history: history },
          _Routes2.default
        )
      ), document.getElementsByClassName('widget')[0]);
    }
  }]);

  return Application;
}();

exports.default = Application;


var app = new Application();

app.start();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/Application.js
// module id = 552
// module chunks = 0